import { useMemo, useState } from 'react';
import { PartnerType, TechnologyType } from '../../types';

export default function useApiIntegrationsTab() {
  const [willIntegrateWithPayroll, setWillIntegrateWithPayroll] = useState(false);
  const [technology, setTechnology] = useState<TechnologyType>({ value: null, label: 'Selecione uma tecnologia' });
  const [integrator, setIntegrator] = useState<PartnerType>({ value: null, label: 'Nenhum integrador' });

  const [technologyOptions, setTechnologyOptions] = useState<TechnologyType[]>([{ value: null, label: 'Selecione uma tecnologia' }]);

  const [hasWebhook, setHasWebhook] = useState(false);
  const [hasResultReadyWebhook, setHasResultReadyWebhook] = useState(false);
  const [hasResultOutOfScopeWebhook, setHasResultOutOfScopeWebhook] = useState(false);

  const isApiIntegrationsTabValid = useMemo(() => ((!!willIntegrateWithPayroll && !!technology.value) || (!willIntegrateWithPayroll)), [technology.value, willIntegrateWithPayroll]);

  return {
    willIntegrateWithPayroll,
    setWillIntegrateWithPayroll,
    technology,
    setTechnology,
    technologyOptions,
    setTechnologyOptions,
    isApiIntegrationsTabValid,
    hasWebhook,
    setHasWebhook,
    hasResultReadyWebhook,
    setHasResultReadyWebhook,
    hasResultOutOfScopeWebhook,
    setHasResultOutOfScopeWebhook,
    integrator,
    setIntegrator,
  };
}
